import { useMemo as u } from "react";
import { isAfter as l, addHours as c, format as n, endOfYear as f, subYears as y, endOfQuarter as M, subQuarters as O, startOfMonth as d, endOfMonth as A, subMonths as L } from "date-fns";
import { getLastFullOfYear as b, getLastFullOfQuarter as i } from "./index.es2483.js";
const p = "MMMM yyyy", Q = "'Q'Q yyyy", F = "yyyy", R = (s = /* @__PURE__ */ new Date()) => {
  const r = {};
  let e = d(s);
  for (let t = 0; t < 6; ++t) {
    const o = n(e, p);
    r[o] = {
      label: o,
      value: [e, A(e)]
    }, e = L(e, 1);
  }
  return r;
}, _ = (s = /* @__PURE__ */ new Date()) => {
  const r = {};
  let e = i(s);
  for (let t = 0; t < 6; ++t) {
    const o = n(e, Q);
    r[o] = {
      label: o,
      value: [e, M(e)]
    }, e = O(e, 1);
  }
  return r;
}, E = (s = /* @__PURE__ */ new Date(), r) => {
  const e = {};
  let t = b(s);
  for (let o = 0; o < 7 && !(r && l(r, c(t, 10))); ++o) {
    const a = n(t, F);
    e[a] = {
      label: a,
      value: [t, f(t)]
    }, t = y(t, 1);
  }
  return e;
}, P = (s, r) => u(() => ({
  months: R(s),
  quarters: _(s),
  years: E(s, r)
}), [s, r]);
export {
  P as useFixedPreset
};
//# sourceMappingURL=index.es5827.js.map
